// extracted by mini-css-extract-plugin
module.exports = {"footerBanner":"FooterOverlay-module_footerBanner_00765","showFooter":"FooterOverlay-module_showFooter_7a568"};